import { __awaiter, __generator } from "tslib";
import { WebAttribution } from '@amplitude/analytics-client-common';
import { isNewCampaign } from '@amplitude/analytics-client-common';
import { isNewSession } from '@amplitude/analytics-client-common';
export var webAttributionPlugin = function webAttributionPlugin(options) {
    var _this = this;
    if (options === void 0) {
        options = {};
    }
    var plugin = {
        name: '@amplitude/plugin-web-attribution-browser',
        type: 'before',
        setup: function setup(config, amplitude) {
            return __awaiter(this, void 0, void 0, function() {
                var webAttribution, pluginConfig, currentCampaign, previousCampaign, isEventInNewSession, campaignEvent;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            webAttribution = new WebAttribution(options, config);
                            return [
                                4 /*yield*/ ,
                                webAttribution.init()
                            ];
                        case 1:
                            _a.sent();
                            pluginConfig = webAttribution.options;
                            currentCampaign = webAttribution.currentCampaign;
                            previousCampaign = webAttribution.previousCampaign;
                            isEventInNewSession = isNewSession(config.sessionTimeout, config.lastEventTime);
                            if (isNewCampaign(currentCampaign, previousCampaign, pluginConfig, isEventInNewSession)) {
                                if (pluginConfig.resetSessionOnNewCampaign) {
                                    amplitude.setSessionId(Date.now());
                                    config.loggerProvider.log('Created a new session for new campaign.');
                                }
                                config.loggerProvider.log('Tracking attribution.');
                                campaignEvent = webAttribution.generateCampaignEvent();
                                amplitude.track(campaignEvent);
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function execute(event) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        event
                    ];
                });
            });
        }
    };
    return plugin;
}; //# sourceMappingURL=web-attribution.js.map
